import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Nosidebar from './Nosidebar.vue'
import Default from './Default.vue'
import VueSession from 'vue-session'
import store from './store'
import vuetify from './plugins/vuetify'
import excel from 'vue-excel-export'
import IdleVue from 'idle-vue'
import VueGeolocation from 'vue-browser-geolocation'
import VueCurrencyInput from 'vue-currency-input'
import '@babel/polyfill'
// Register a global custom directive called `v-role`
Vue.directive('role', { inserted: function (el, binding) {
  const fnc = require('./config/check-role')
  // passing parameter which is the role of logged user. the pr co,es from, directive
  fnc.check_role(binding.value)
}
})
Vue.use(VueCurrencyInput)
Vue.use(VueGeolocation)
Vue.use(VueSession)
Vue.use(excel)
Vue.component('no-sidebar-layout', Nosidebar)
Vue.component('default-layout', Default)

const eventsHub = new Vue()

//= =======Controla o tempo de actividade do usuário =======================================
Vue.use(IdleVue, {

  eventEmitter: eventsHub,
  idleTime: 1000000

})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
